import React, { useState } from "react";
import style from "./../NewPost.module.scss";
import classNames from "classnames";
import { Button } from "reactstrap";
import { LoadingMessage } from "../../Summary";
import { Combobox } from "../../../../Order/Field/Field";
import LaddaButton, { SLIDE_DOWN } from "react-ladda";

const SendFile = ({ file, personType, alias, fileTypes, fetchs, toggle, props }) => {
  const [selectedType, setSelectedType] = useState(-1);
  const [sending, setSending] = useState(false);

  const send = () => {
    setSending(true);

    fetchs.send(
      {
        eventId: file.eventId,
        eventHistoryId: file.eventHistoryId,
        eventHistoryFileId: file.id,
        subTypeId: selectedType,
      },
      (r) => {
        setSending(false);
        toggle(file.id);
      }
    );
  };

  return (
    <div className={style.send}>
      <div className={style.child}>
        <button
          type="button"
          className={classNames("close", style.close)}
          aria-label="Close"
          onClick={() => toggle()}
        >
          <span aria-hidden="true">×</span>
        </button>

        {fileTypes == null ? (
          <LoadingMessage text={"Retrieving types"} />
        ) : (
          <React.Fragment>
            <h6>Send file to: {alias}</h6>
            <span onClick={() => props.download(file)}>{file.name}</span>

            <div className={style.inputs}>
              <Combobox
                style={{ background: "#edf9ff", fontWeight: 500 }}
                value={selectedType}
                disabled={sending}
                emptyLabel={"File type"}
                onChange={(v) => setSelectedType(v)}
                items={fileTypes.map((type) => ({
                  id: type.ArchiveSubTypeId,
                  description: type.ArchiveSubTypeDescription,
                }))}
              />{" "}
              <LaddaButton
                className={"btn btn-ladda btn-primary"}
                loading={sending}
                disabled={selectedType == -1}
                onClick={() => send()}
                data-style={SLIDE_DOWN}
              >
                {"Send"}
              </LaddaButton>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default SendFile;
